import React from "react";
import '../../styles/common/back-button.scss';
import {FontIcon} from "./FontIcon";
import { useNavigate } from "react-router-dom";
import {inAppAnalyticsService, ButtonIdentifier} from "../../services/inAppAnalyticsService";

interface IBackButtonProps{
  label?: string;
  useClassName?: string;
  onClick?: () => void; // Override the default behavior
  analyticsIdentifier?: ButtonIdentifier; // When set, fires a button_press analytics event on tap.
  analyticsScreenClass?: string; // The screen_class context for the analytics event.
}
export default function BackButton({label="Back", useClassName, onClick, analyticsIdentifier, analyticsScreenClass}: IBackButtonProps) {
  const navigate = useNavigate();

  // This logic is also used in the BackButton component.  Search the codebase for c0928j09 to see it.
  const goBack = () => {
    // React router doesn't have a built-in way to know if the history stack is empty.
    // So we use the browser's history object to do so.
    // https://developer.mozilla.org/en-US/docs/Web/API/History/length
    if (!(history.length > 1)) {
      navigate('/dashboard');
      return;
    }

    // The equivalent of calling history.back() in the browser, but through React Router.
    // https://developer.mozilla.org/en-US/docs/Web/API/History/go#examples
    // https://reactrouter.com/en/main/hooks/use-navigate
    navigate(-1);
  };

  const handleClick = () => {
    if (analyticsIdentifier) {
      inAppAnalyticsService.onButton_press(analyticsIdentifier, analyticsScreenClass ? {screenClass: analyticsScreenClass} : undefined);
    }
    (onClick ?? goBack)();
  };

  return (
    <button className={`back-button ${useClassName ?? ``}`} onClick={handleClick}>
      <FontIcon icon={'icon-arrow-left'}/><span className={"label"}>{label}</span>
    </button>
  );
}
